/* Fuerto — výkon (21. 9. 2026)
   Druhá fotka na kartě produktu (ta „na ruce") se stahuje až ve chvíli,
   kdy na kartu najedeš myší nebo na ni přejdeš klávesnicí. Na mobilu
   (bez myši) se nestahuje vůbec. Dřív se stahovala u všech karet hned. */
(function () {
  if (!window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  function ready(img) { img.classList.add('is-ready'); }

  function load(card) {
    var img = card && card.querySelector('img.fz-card-alt[data-srcset]');
    if (!img || img.dataset.fzLoaded) return;
    img.dataset.fzLoaded = '1';
    img.addEventListener('load', function () { ready(img); }, { once: true });
    if (img.dataset.sizes) img.sizes = img.dataset.sizes;
    img.srcset = img.dataset.srcset;
    if (img.complete && img.naturalWidth > 1) ready(img);
  }

  function onIntent(e) {
    var t = e.target;
    if (!t || !t.closest) return;
    load(t.closest('.fz-card-wrap'));
  }

  document.addEventListener('pointerover', onIntent, { passive: true });
  document.addEventListener('focusin', onIntent);
})();
